import { PropsWithChildren, useCallback, useState } from 'react';
import { BreadcrumbState, SnackBarContext, UIContext } from '@ev-tech/eva-container-api';

const notImplemented = () => {
  throw new Error('Not implemented');
};
const noop = () => {};

export function UiContextProvider({ children }: PropsWithChildren) {
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbState>({
    current: '',
    breadcrumbs: [],
  });
  const clearBreadcrumb = useCallback(() => setBreadcrumb({ current: '', breadcrumbs: [] }), []);

  const [openDrawerList, setOpenDrawerList] = useState<string[]>([]);
  const getIsDrawerOpen = useCallback((name: string) => openDrawerList.includes(name), [openDrawerList]);

  const setDrawerOpen = useCallback((name: string, open: boolean) => {
    setOpenDrawerList((state) => (open ? [...state, name] : state.filter((drawerName) => drawerName !== name)));
  }, []);

  const isAnyDrawerOpen = openDrawerList.length > 0;

  return (
    <UIContext.Provider
      value={{
        breadcrumb,
        setBreadcrumb,
        clearBreadcrumb,
        openPopovers: [],
        setOpenPopovers: notImplemented,
        setDrawerOpen,
        getIsDrawerOpen,
        isAnyDrawerOpen,
        isLayoutDeactivated: false,
        deactivateLayout: notImplemented,
        desktopTopBarHeight: 0,
        mobileTopBarHeight: 0,
      }}
    >
      <SnackBarContext.Provider
        value={{ openSnackBar: () => '', closeSnackBar: noop, openErrorDialog: notImplemented }}
      >
        {children}
      </SnackBarContext.Provider>
    </UIContext.Provider>
  );
}
